import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadContacts();
  }, []);

  const loadContacts = async () => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/admin/contacts`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await response.json();
      setContacts(data);
    } catch (error) {
      console.error('Error loading contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <img src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w" alt="Logo" className="h-10 w-10" />
              <h1 className="text-xl font-bold text-gray-900">Contact Messages</h1>
            </div>
            <button onClick={handleLogout} className="text-red-600 hover:text-red-700">
              <i className="ri-logout-box-line"></i> Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="flex">
        <div className="w-64 bg-white h-screen shadow-sm">
          <nav className="p-4 space-y-2">
            <Link to="/admin/dashboard" className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg">
              <i className="ri-dashboard-line text-xl"></i><span>Dashboard</span>
            </Link>
            <Link to="/admin/bookings" className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg">
              <i className="ri-calendar-check-line text-xl"></i><span>Bookings</span>
            </Link>
            <Link to="/admin/contacts" className="flex items-center space-x-3 px-4 py-3 bg-blue-50 text-blue-700 rounded-lg font-medium">
              <i className="ri-message-3-line text-xl"></i><span>Contacts</span>
            </Link>
            <Link to="/admin/reviews" className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg">
              <i className="ri-star-line text-xl"></i><span>Reviews</span>
            </Link>
            <Link to="/admin/settings" className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg">
              <i className="ri-settings-3-line text-xl"></i><span>Settings</span>
            </Link>
          </nav>
        </div>

        <div className="flex-1 p-8">
          <div className="bg-white rounded-xl shadow-sm border">
            {loading ? (
              <div className="p-8 text-center text-gray-500">Loading...</div>
            ) : contacts.length === 0 ? (
              <div className="p-8 text-center text-gray-500">No contact messages</div>
            ) : (
              <div className="divide-y">
                {contacts.map((contact) => (
                  <div key={contact.id} className="p-6 hover:bg-gray-50">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="font-semibold text-gray-900">{contact.name}</h3>
                        <p className="text-sm text-gray-600">{contact.email}</p>
                        {contact.phone && <p className="text-sm text-gray-600">{contact.phone}</p>}
                      </div>
                      <span className="text-xs text-gray-500">
                        {new Date(contact.created_at).toLocaleDateString()}
                      </span>
                    </div>
                    {contact.service && (
                      <p className="text-sm text-blue-600 mb-2">
                        <i className="ri-service-line"></i> {contact.service}
                      </p>
                    )}
                    <p className="text-gray-700">{contact.message}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
